import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'

import { explorerApi } from '~/api/client'
import { EvmSearchHandlerInfo } from '~/api/repository'
import { searchHandlerKey } from '~/api/service/query-keys.const'
import { searchFilterType } from '~/types/search.type'
import type { ITokenType } from '~/types/token-type.type'

export const useFetchSearchHandler = (term: Ref<string>, filterBy: Ref<searchFilterType>, isEnable?: Ref<boolean>) => {
  return useQuery([ ...searchHandlerKey, term, filterBy ], (): Promise<ViewSearchHandlerInfo> => {
    return explorerApi.searchController.search({
      requestBody: {
        term: term.value,
        filterBy: filterBy.value
      }
    }).then((res) => {
      return searchHandlerDto(res as EvmSearchHandlerInfo[])
    })
  }, { enabled: isEnable })
}

export type TokenSearchResult = {
  ADDR: string;
  IMG: string;
  NM: string;
  SB: string;
  TTP: ITokenType;
}

export type ViewSearchHandlerInfo = {
  totalCount: number;
  resultMap: Map<searchFilterType, Array<string> | Array<TokenSearchResult>>
}

const searchHandlerDto = (resultList: EvmSearchHandlerInfo[]): ViewSearchHandlerInfo => {
  const searchResultMap = new Map<searchFilterType, Array<string> | Array<TokenSearchResult>>()

  for (const filter in searchFilterType) {
    searchResultMap.set(filter as searchFilterType, [])
  }

  const setSlicedResult = (key1: searchFilterType, key2?: searchFilterType) => {
    const total = 10
    const limit = 5
    const sliceCount = key2 ? total - Math.min(searchResultMap.get(key2)!.length, limit) : total
    searchResultMap.set(key1, searchResultMap.get(key1)!.slice(0, sliceCount))
  }

  resultList.forEach((result: EvmSearchHandlerInfo) => {
    if (result.ID === searchFilterType.TOKEN) {
      searchResultMap.set(result.ID, result.SRLIST as Array<TokenSearchResult>)
    } else {
      searchResultMap.set(result.ID, result.SRLIST as Array<string>)
    }
  })

  setSlicedResult(searchFilterType.BLOCK)
  setSlicedResult(searchFilterType.TRANSACTION, searchFilterType.ADDRESS)
  setSlicedResult(searchFilterType.ADDRESS, searchFilterType.TRANSACTION)
  setSlicedResult(searchFilterType.TOKEN)

  return {
    totalCount: Array.from(searchResultMap.values()).flat().length,
    resultMap: searchResultMap,
  }
}